import C from './components/C_ZA';
import { Z1_A } from './components/Z1_A';
import Z2 from './components/Z2';
import Z3 from './components/Z3';
import Z4 from './components/Z4';
import Z5 from './components/Z5';
import Z6 from './components/Z6';
import Z7 from './components/Z7';
import Z8 from './components/Z8';
import Z9 from './components/Z9';
import { ZBComp } from './components/ZB';
import { ZCComp } from './components/ZC';
import { ZDComp } from './components/ZD';
import { ZEComp } from './components/ZE';
import { ZEComp_PH } from './components/ZE_PH';
import { ZFComp } from './components/ZF';
import { ZGComp } from './components/ZG';
import { ZHComp } from './components/ZH';
import { ZIComp } from './components/ZI';
import { ZKComp } from './components/ZK';
import { BundleList } from '@/components/ProductCommon/bundle-list';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvPC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const BundleLists: any = {
    us: ['d2m220', 'd2m400', 'd2mWave2'],
    ca: ['d2m220', 'd2m400', 'd2mWave2'],
    eu: ['d2mEB', 'd2m220', 'd2m400'],
    uk: ['d2mEB', 'd2m220', 'd2m400'],
    de: ['d2mEB', 'd2m220', 'd2m400'],
    fr: ['d2mEB', 'd2m220', 'd2m400'],
    it: ['d2mEB', 'd2m220', 'd2m400'],
    es: ['d2mEB', 'd2m220', 'd2m400'],
    jp: ['d2mWave2', 'd2m220', 'd2mEB'],
    ph: ['d2m220', 'd2m400', 'd2mPS'],
};

export default function IndexDynamicEU({ stage }: any) {
    const { gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const otherProductData = getDetaileMoreProducts(gloproductlist, [
        'product_ps_river_river_256',
        'product_ps_delta_delta_2',
        'product_sp_220w_bi_solar_panel',
    ]);
    return (
        <>
            {stage === 'teaser' && (
                <div className="common-comp-wrapper">
                    <Z1_A />
                </div>
            )}
            <Z2 />
            {locale === 'za' && <C />}
            {locale === 'cn' ? <Z9 /> : <Z3 />}
            <Z4 />
            <Z5 />
            <Z6 />
            <Z7 />
            <Z8 />
            {locale === 'cn' ? <Z3 /> : <Z9 />}
            <div className="common-comp-wrapper">
                <ZBComp />
            </div>
            <div className="common-comp-wrapper">
                <ZCComp />
            </div>
            {!['jp', 'cn'].includes(locale) && (
                <div className="common-comp-wrapper">
                    <ZDComp />
                </div>
            )}
            <div className="common-comp-wrapper">{locale === 'ph' ? <ZEComp_PH /> : <ZEComp />}</div>
            <div className="common-comp-wrapper">
                <ZFComp />
            </div>
            <div className="common-comp-wrapper">
                <ZGComp />
            </div>
            <div className="common-comp-wrapper">
                {!SHOW_APP_POINT_SITES.includes(locale) && <ZHComp />}
                {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaAdv theme={locale === 'ph' ? 'white' : 'black'} />}
            </div>
            <div className="common-comp-wrapper" style={{ marginTop: SHOW_APP_POINT_SITES ? '0' : '220px' }}>
                <ZIComp />
            </div>
            <div className="common-comp-wrapper">
                <ZKComp />
            </div>
            {/* 预热页不展示推荐产品 */}
            {stage === 'detail' && !['sa', 'za', 'tw'].includes(locale) && (
                <>
                    {!['cn'].includes(locale) && (
                        <div className="common-comp-wrapper">
                            <BundleList
                                list={BundleLists[locale] || BundleLists.eu}
                                moreUrl={`https://${locale}.ecoflow.com/collections/smart-devices`}
                                theme="grey"
                            />
                        </div>
                    )}
                    {['cn'].includes(locale) && <OtherList theme="" data={otherProductData} />}
                </>
            )}
        </>
    );
}
